export default {
  data () {
    return {
      debouncer: null
    }
  },

  methods: {
    debounces (fn, ms = 500) {
      if (this.debouncer) {
        window.clearTimeout(this.debouncer)
        this.debouncer = null
      }

      this.debouncer = window.setTimeout(() => {
        fn()
        this.debouncer = null
      }, ms)
    }
  },

  beforeDestroy () {
    if (this.debouncer) {
      window.clearTimeout(this.debouncer)
    }
  }
}
